import * as z from "zod";

export const findUsernameSchema = z.object({
    email: z
    .string()
    .email("유효한 이메일 주소를 입력해주세요."),
});

// 🔹 타입 정의
export type FindUsernameFormValues = z.infer<typeof findUsernameSchema>;